export enum CancelConfirmPageMode {
  CONFIRM = 'confirm',
  CANCEL = 'cancel',
  CONFIRMED = 'confirmed',
  CANCELED = 'canceled',
  ERROR = 'error',
}

export interface ConfirmCancelErrorProps {
  response?: {
    data?: {
      code?: string;
    };
  };
}
